import { formatDate } from "../../utils/helper";

const FuelMapCard = ({ event }) => {
    return (
        <div style={{ maxWidth: '160px' }}>
            <div>
                <p style={{ color: "red", fontSize: "22px !important", fontWeight: "600", marginBottom: "4px" }}>Refuel - {event.claimed_fueled}</p>

                <p style={{ color: '#5c5252', fontWeight: '400', marginBottom: "10px", fontSize: "14px !important" }}>
                    {event?.fuel_station.name}
                </p>
            </div>

            <div style={{ fontSize: '12px', fontWeight: '500', color: '#333', marginBottom: '2px' }}>
                {formatDate(event.refuel_at)}
            </div>
        </div>
    );
};

export default FuelMapCard;
